export const multiMenuItemStyle = {
    padding: 0,
    backgroundColor: 'transparent !important'
};
export const multiCheckboxStyle = {
    padding: '8px 8px 8px 0'
};
